/**
 * Event type unions mirrored from Backend/src/lib/monitoringTypes.ts. Used to
 * populate filter dropdowns; unknown values from the API still render fine.
 */
export const SECURITY_EVENT_TYPES = [
  'RATE_LIMITED',
  'BLOCKED_IP_HIT',
  'SERVER_ERROR',
  'SUSPICIOUS_USER_AGENT',
  'ACCOUNT_STATUS_CHANGED',
  'ORG_STATUS_CHANGED',
  'FORCE_LOGOUT',
  'REVOKED_SESSION_USED',
  'SCANNER_PROBE',
] as const;

export const AUTH_EVENT_TYPES = [
  'LOGIN_SUCCESS',
  'LOGIN_FAILED',
  'LOGIN_BLOCKED',
  'REGISTER',
  'EMAIL_CONFIRMED',
  'SOCIAL_LOGIN',
  'DEMO_LOGIN',
  'LOGOUT',
  'REFRESH_REJECTED',
  'MFA_CHALLENGE',
  'MFA_SUCCESS',
  'MFA_FAILED',
  'PASSWORD_RESET_REQUESTED',
  'PASSWORD_RESET_COMPLETED',
  'MAGIC_LINK_REQUESTED',
  'RATE_LIMITED',
] as const;
